import React, { Component } from 'react';

import NoticeList from 'components/News/Notice/List';
import PageTitleBar from 'components/misc/PageTitleBar';
import TabBar from 'components/misc/TabBar';

const tabBarMenus = [
  { name: '새메뉴', link: '/news/new/' },
  { name: '이벤트', link: '/news/event/' },
  { name: '공지사항', link: '/news/notice/' },
];

class NoticeListPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      location: null,
    };
  }

  componentDidMount() {
    this.setState({
      location: window.location,
    });
  }

  render() {
    const { location } = this.state;
    const id = location !== null ? location.search.substring(1) : null;

    return (
      <div>
        <PageTitleBar title="Notice" backgroundImage={require('../../assets/images/banner/news.jpg')} />
        <TabBar index={2} data={tabBarMenus} />
        <NoticeList id={id} />
      </div>
    );
  }
}

export default NoticeListPage;
